// The auth screens' own copy, added to the app's i18next resources (shared/i18n holds the core and generated keys;
// field and problem texts come from the generated catalogue).
import { i18next } from '../../shared/i18n/i18n'
import cs from './auth.cs.json'
import en from './auth.en.json'

i18next.addResourceBundle('en', 'translation', en, true)
i18next.addResourceBundle('cs', 'translation', cs, true)
